import * as React from 'react';

export const IconWarning = (props: React.HTMLAttributes<SVGElement>) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 11">
    <g fill="none" fillRule="evenodd">
      {/* tslint:disable-next-line:max-line-length */}
      <path
        fill="currentColor"
        d="M.827 11C.19 11-.206 10.287.112 9.717L5.285.427a.81.81 0 0 1 1.43 0l5.173 9.29c.318.57-.08 1.283-.715 1.283H.827z"
      />
      <path fill="#FFF" d="M7 9a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
      {/* tslint:disable-next-line:max-line-length */}
      <path
        fill="#FFF"
        d="M6 4c-.552 0-1 .36-1 .804C5 5.248 5.302 8 5.854 8h.292C6.698 8 7 5.248 7 4.804 7 4.36 6.552 4 6 4"
      />
    </g>
  </svg>
);
